import moment from 'moment';

export default {
  methods: {
    convertDate(val) {
      if(this.$i18n.locale === 'en') {
        return moment(val).format('MM/DD/YYYY');
      } else {
        return moment(val).format('YYYY/MM/DD');
      }
    },
  },
};
